import { render, staticRenderFns } from "./KnIncomeCategories.vue?vue&type=template&id=5268455c&"
import script from "./KnIncomeCategories.vue?vue&type=script&lang=js&"
export * from "./KnIncomeCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports